var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.note)?_c('div',{staticClass:"font-weight-bold metric-yellow"},[_vm._v(" "+_vm._s(_vm.note)+" ")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }